import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography, Card, Input, IconButton } from "@material-tailwind/react";
import { Search, Sort } from "iconoir-react";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { updatePartsRequest, listPartsSuccess } from "../../../../redux/parts/actions";
import { getMoneyFormat } from "../../../../utils/formatViews";
import { Part } from "../../../../redux/vehicles/actions";
import Loader from "../../../../components/Loader";
import { RootState } from "../../../../redux";
import { DialogRequestPart } from "./DialogRequestPart";
import AppImages from "../../../../assets/AppImages";

const TABLE_HEAD = [
    {n: "Part Name", className: ""},
    {n: "Part Number", className: ""},
    {n: "Quantity", className: ""},
    {n: "Cost", className: ""},
    { n: "", className: "w-12" },
    // {n: "Condition", className: ""},
];

export function DashboardVehicleInventoryTabParts() {
    const dispatch = useDispatch();
    const { vehicle } = useSelector((state: RootState) => state.vehicles);
    const { parts } = useSelector((state: RootState) => state.parts);
    const [isOpen, setIsOpen] = React.useState(false);

    const onSubmit = (part: Part) => {
        setIsOpen(false);
        dispatch(
            updatePartsRequest({
                parts: [{ ...part, vehicle_id: vehicle?.id }],
                update_fields: ["name", "vehicle_id", "number", "qty", "note"],
            })
        );
    }

    return !vehicle ? (
        <Loader />
    ) : (
        <React.Fragment>
            <Card className="p-5">
                <Card.Header className="w-full m-0 items-start rounded-none flex flex-wrap gap-4 justify-between p-4">
                    <div>
                        <Typography type="lead" color="default" className="font-semibold mb-1">
                            Part List
                        </Typography>
                        <Typography type="small" className="text-foreground block">
                            Detailed parts for easy reference and procurement.
                        </Typography>
                    </div>
                    <div className="flex flex-col sm:flex-row items-center w-full shrink-0 gap-3 md:w-max">
                        <Input placeholder="Search here..." className="w-full sm:w-72">
                            <Input.Icon>
                                <Search className="w-full h-full" />
                            </Input.Icon>
                        </Input>
                        <div className="flex gap-3 sm:w-max w-full">
                            <Button
                                variant="outline"
                                color="secondary"
                                className="flex items-center gap-2 sm:w-auto w-full"
                            >
                                Filter
                                <Sort className="w-4 h-4" />
                            </Button>
                            <Button
                                color="primary"
                                onClick={() => setIsOpen(true)}
                                className="flex w-max items-center gap-2"
                            >
                                Request Part
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body className="mt-4 p-0 rounded-none max-h-[calc(100vh-340px)] overflow-y-auto scrollbar-hide">
                    <table className="w-full min-w-max table-auto">
                        <thead>
                            <tr>
                                {TABLE_HEAD.map((el, idx: number) => (
                                    <th
                                        key={idx}
                                        className={`sticky top-0 bg-white z-10 border-b text-start border-surface p-4 ${el.className}`}
                                    >
                                        <Typography
                                            type="small"
                                            color="default"
                                            className="block font-medium"
                                        >
                                            {el.n}
                                        </Typography>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {parts.map((el, idx: number) => (
                                <tr key={idx} className="h-20">
                                    <td className="p-4 border-b border-surface">
                                        <Typography color="primary" className="block font-bold">
                                            {el.name}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface">
                                        <Typography type="small" className="block text-foreground">
                                            {el.number}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface">
                                        <Typography type="small" className="block text-foreground">
                                            {el.qty}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface">
                                        <Typography type="small" className="block text-foreground">
                                            {getMoneyFormat(el.cost)}
                                        </Typography>
                                    </td>
                                    {/* <td className="p-4 border-b border-surface">
                                        <Chip
                                            size="sm"
                                            isPill={false}
                                            className="w-max"
                                            color={getPartStatusColor(el.condition)}
                                        >
                                            <Chip.Label>{el.condition}</Chip.Label>
                                        </Chip>
                                    </td> */}
                                    <td className="p-4 border-b border-surface">
                                        <IconButton
                                            variant="ghost"
                                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                if (e) {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                }

                                                withReactContent(Swal)
                                                    .fire({
                                                        title: "Are you sure?",
                                                        text: "You won't be able to revert this!",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#3085d6",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Yes, delete it!",
                                                    })
                                                    .then((result) => {
                                                        if (result.isConfirmed) {
                                                            dispatch(
                                                                updatePartsRequest({
                                                                    parts: parts
                                                                        .filter(
                                                                            (t) => t.id === el.id
                                                                        )
                                                                        .map((t) => ({
                                                                            id: t.id,
                                                                            is_removed: true,
                                                                        })),
                                                                    update_fields: [
                                                                        "id",
                                                                        "is_removed",
                                                                    ],
                                                                })
                                                            );
                                                            dispatch(
                                                                listPartsSuccess({
                                                                    data: parts.filter(
                                                                        (t) => t.id !== el.id
                                                                    ),
                                                                    save_as: "parts",
                                                                })
                                                            );
                                                        }
                                                    })
                                                    .catch((error: any) => {
                                                        console.log("error", error);
                                                    });
                                            }}
                                        >
                                            <AppImages.iconTrash className="text-error w-5 h-5" />
                                        </IconButton>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card.Body>
            </Card>

            {isOpen && (
                <DialogRequestPart isOpen={isOpen} setIsOpen={setIsOpen} onSubmit={onSubmit} />
            )}
        </React.Fragment>
    );
}
